// extracted by mini-css-extract-plugin
export default {"barChipStack":"ou_ov","barChipStack_vertical":"ou_ow"};